import React from "react";

interface Props {
  stage: server.dto.Stage
}

const Stage = ({ stage }: Props) => {
  return <table className="s1_table clean">
    <tbody>
      {stage.width && <tr>
        <td>{RESX.Venue.StageWidth}</td>
        <td>{stage.width} m</td>
      </tr>}

      {stage.depth && <tr>
        <td>{RESX.Venue.StageDepth}</td>
        <td>{stage.depth} m</td>
      </tr>}

      {stage.toFloor && <tr>
        <td>{RESX.Venue.StageToFloor}</td>
        <td>{stage.toFloor} m</td>
      </tr>}

      {stage.toCeiling && <tr>
        <td>{RESX.Venue.StageToCeiling}</td>
        <td>{stage.toCeiling} m</td>
      </tr>}
    </tbody>
  </table>;
};

export default Stage;